import ProductDashboardContainer from './ProductDashboardContainer';
export default ProductDashboardContainer;
